
export class Log{
    message: string;
    pointer: string;
    time: number;
    constructor(time: number, message:string, pointer?:string) {
        this.message = message;
        this.pointer = pointer;
        this.time = time;
    }
    
}